import * as React from 'react'
import dynamic from 'next/dynamic'

import { spacing, styled, Text, mq } from '@thg-commerce/enterprise-theme'
import { HorizontalAlignment } from '@thg-commerce/enterprise-core'
import { Button } from '@thg-commerce/gravity-elements'

const EyeIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/Eye'),
)
const CloseIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/Close'),
)

export const ShopTheLookContainer = styled.div<{ hasItemActive?: boolean }>`
  position: relative;
  ${(props) => props.hasItemActive && `z-index:3`}
`

export const Title = styled.p<{ horizontalAlignment?: HorizontalAlignment }>`
  ${Text('xlarge1', 'alternate')};
  margin-bottom: ${spacing(1)};
  text-align: ${(props) => props.horizontalAlignment || 'center'};
`

export const Description = styled.p<{
  horizontalAlignment?: HorizontalAlignment
}>`
  ${Text('bodyText', 'default')};
  text-align: ${(props) => props.horizontalAlignment || 'center'};
  margin-bottom: ${spacing(4)};
`

export const ImageContainer = styled.div`
  position: relative;
  z-index: 1;
`

export const StyledHotSpot = styled.button<{
  top: string
  left: string
  primary?: boolean
}>`
  position: absolute;
  z-index: 2;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  border: 1px solid ${(props) => props.theme.colors.palette.greys.dark};
  border-radius: 50%;
  background: ${(props) =>
    props.primary
      ? props.theme.colors.palette.greys.white
      : props.theme.colors.palette.brand.base};
  :hover {
    background: ${(props) => props.theme.colors.palette.greys.lighter};
    border: 2px solid ${(props) => props.theme.colors.palette.greys.dark};
    path {
      fill: ${(props) => props.theme.colors.palette.brand.base};
    }
    .outside-circle {
      fill: ${(props) => props.theme.colors.palette.greys.white};
    }
    .inside-circle {
      fill: ${(props) => props.theme.colors.palette.brand.base};
    }
  }
  :focus {
    outline: 2px solid ${(props) => props.theme.colors.palette.brand.base};
    ${(props) =>
      !props.primary &&
      `background-color: ${props.theme.colors.palette.greys.lighter};`}
    path {
      fill: ${(props) => props.theme.colors.palette.brand.base};
    }
    .outside-circle {
      fill: ${(props) => props.theme.colors.palette.greys.lighter};
    }
    .inside-circle {
      fill: ${(props) => props.theme.colors.palette.brand.base};
    }
  }
`

export const StyledEyeIcon = styled(({ primary, ...props }) => (
  <EyeIcon {...props} />
))<{ primary?: boolean }>`
  path {
    fill: ${(props) =>
      props.primary
        ? props.theme.colors.palette.brand.base
        : props.theme.colors.palette.greys.lighter};
  }
  .outside-circle {
    fill: ${(props) =>
      props.primary
        ? props.theme.colors.palette.greys.white
        : props.theme.colors.palette.brand.base};
  }
  .inside-circle {
    fill: ${(props) =>
      props.primary
        ? props.theme.colors.palette.brand.base
        : props.theme.colors.palette.greys.lighter};
  }
`

export const StyledCloseIcon = styled(({ primary, ...props }) => (
  <CloseIcon {...props} />
))<{ primary?: boolean }>`
  width: 16px;
  height: 16px;
  path {
    fill: ${(props) =>
      props.primary
        ? props.theme.colors.palette.brand.base
        : props.theme.colors.palette.greys.white};
  }
`

export const StyledButton = styled(Button)`
  margin-top: ${spacing(2)};
`

export const ProductDetailsContainer = styled.div`
  background: ${(props) => props.theme.colors.palette.greys.white};
  padding: ${spacing(3)};
  max-width: 288px;
  max-height: 545px;
  overflow-y: auto;
  z-index: 3;
  position: absolute;
  top: 0;
  right: 0;
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    max-width: 300px;
  }
`

const CloseButton = styled.button`
  margin: calc(${spacing(1)} - 2px);
  outline: none;
  border: 2px solid transparent;

  &:hover,
  &:focus {
    opacity: 0.8;
  }

  &:active svg path {
    fill: ${(props) => props.theme.colors.palette.greys.darker};
  }
  &:focus {
    border: 2px solid ${(props) => props.theme.colors.palette.brand.base};
  }
`

export const AbsoluteCloseButton = styled(CloseButton)`
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  z-index: 4;
`

export const StyledCloseWrapper = styled.div`
  display: flex;
  padding: ${spacing(1)};
  align-items: center;
`

export const StyledCloseText = styled.div`
  ${Text('bodyText', 'alternate')}
  padding-right: ${spacing(1)};
`
